module.exports = __webpack_public_path__ + "media/maryse.3aeb550c.mp4";